import navsync from "../../../../assets/images/blogs/pp10/navsync.mp4";
import syncedInteractions from "../../../../assets/images/docs/syncedinteractions.png";
import * as React from 'react';
export default {
  navsync,
  syncedInteractions,
  React
};